export default function enforceObjPath(obj, path) {
  if (!(path in obj)) {
    var err = new Error();
    err.name = 'PropertyMissing';
    err.message = 'Required property ' + path + ' missing from:\n\n' + JSON.stringify(obj) + '\n\n';
    throw err;
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/node_modules/contentful-sdk-core/dist/es-modules/enforce-obj-path.js
// module id = ../../../../contentful-sdk-core/dist/es-modules/enforce-obj-path.js
// module chunks = vendor